import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ActHttpService } from '../act-http/act-http.service';
import { environment } from 'environments/environment';
import { Quotation } from 'app/model/mice/mice.model'
import { GalleryList } from '../../model/mice/mice.model';

@Injectable()
export class MiceService {

  constructor(private actHttpService: ActHttpService) { }

  sendQuotation(data: Quotation): Observable<any> {
    const url = environment.endpoint.miceQuotation;
    return this.actHttpService.rawPost(url, data)
      .map((res: Response) => res.json());
  }

  getGallery(): Observable<GalleryList> {
    return this.actHttpService.rawGet('../../../assets/mice/dataGallery.json')
    .map((res: any) => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/services/mice/mice.service.ts